import { IPosition } from '../../../core/services/job-position/job-position.service';
import { ICompanyData } from '../../../core/entities/company-data';

export interface IChatUser {
  first_name?: string;
  last_name?: string;
  photo?: string;
  username?: string;
  _id?: string;
  position?: {
    id: string;
    other: boolean;
    value: string;
  };
  employer_company?: ICompanyData;
}

export class ChatUser {
  first_name: string;
  last_name: string;
  photo: string;
  username: string;
  _id: string;
  fullname: string;
  position?: {
    id: string;
    other: boolean;
    value: string;
  };
  employer_company?: ICompanyData;

  constructor(user: IChatUser) {
    this.first_name = user.first_name;
    this.last_name = user.last_name;
    this.photo = user.photo;
    this.username = user.username;
    this._id = user._id;
    this.fullname = `${this.first_name} ${this.last_name}`;
    this.position = user.position;
    this.employer_company = user.employer_company;
  }
}



// WEBPACK FOOTER //
// ./app/states/chat/models/chat-user.ts